// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/practice/styles/PracticeYay.scss
// module id = 1478
// module chunks = 0